<dialogContent>
  <tt-form-field id="proposed-type-select">
    <label for="proposed-type-select" ttLabel>{{ 'FlowchartElement' | transloco }}:</label>
    <tt-select [(ngModel)]="proposedType">
      <tt-select-items>
        <tt-option [value]="flowchartElementType.FlowchartAction">{{ 'Flowchart.AddAction' | transloco }}</tt-option>
        <tt-option [value]="flowchartElementType.FlowchartDecisionNode">{{ 'Flowchart.AddDecision' | transloco }}</tt-option>
      </tt-select-items>
    </tt-select>
  </tt-form-field>
</dialogContent>

<dialogActions class="actions">
  <button ttButton variant="primary" (click)="closeDialog()">
    <span>{{ 'Continue' | transloco }}</span>
  </button>
</dialogActions>
